module.exports = __webpack_public_path__ + "static/media/389.813fc8ab.svg";